(function () {
  document.querySelectorAll('[data-announcement-bar]').forEach(function (bar) {
    var slides = Array.prototype.slice.call(bar.querySelectorAll('[data-announcement-slide]'));
    if (slides.length < 2) return;

    var current = slides.findIndex(function (slide) {
      return slide.classList.contains('announcement-bar__slide--active');
    });
    if (current < 0) current = 0;

    function show(index) {
      slides[current].classList.remove('announcement-bar__slide--active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('announcement-bar__slide--active');
    }

    var prev = bar.querySelector('[data-announcement-prev]');
    var next = bar.querySelector('[data-announcement-next]');

    var interval = parseInt(bar.getAttribute('data-interval'), 10) || 0;
    var timer = null;

    function stop() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    function start() {
      if (interval <= 0) return;
      stop();
      timer = setInterval(function () { show(current + 1); }, interval);
    }

    function restart() { stop(); start(); }

    if (prev) prev.addEventListener('click', function () { show(current - 1); restart(); });
    if (next) next.addEventListener('click', function () { show(current + 1); restart(); });

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    start();
  });
})();
